<template lang="pug">
    section#conteudo
        .wrapper
            h2 Selecione o assunto abaixo e em seguida a pergunta relacionada com a sua dúvida.
            Loader(tamanho="large", v-if="!categorias.length").verde
            ul(v-else)#categorias
                li.categoria(v-for="categoria, indexC in listCategories")
                    a(href="#", @click.prevent="loadPerguntas(indexC, categoria.id)").texto {{ categoria.nome }}
                    ul(:class="{'ativo': categoriasAtivas.includes(indexC)}")#perguntas
                        li.pergunta(v-for="pergunta, indexP in categoria.perguntas")
                            a(href="#", @click.prevent="toggleItem(indexP, categoria.perguntasAtivas)").texto {{ pergunta.pergunta }}
                            div.resposta(v-html="pergunta.resposta", :class="{'ativo': categoria.perguntasAtivas.includes(indexP)}")
</template>

<script>
import Loader from '@components/Loader/Loader'

export default {
    name: "section-conteudo",
    components: {
        Loader
    },
    data() {
        return {
            categorias: [],
            categoriasAtivas: []
        }
    },
    created() {
        this.loadCategorias();
    },
    computed: {
        listCategories() {
            return this.categorias.filter(category => category.id !== 3)
        }
    },
    methods: {
        loadCategorias() {
            this.$axios
                .get(`faq/categorias`)
                .then(response => {
                    this.categorias = response.data.registros;
                    this.categorias.forEach(categoria => {
                        categoria.perguntas = []
                        categoria.perguntasAtivas = []
                    });
                })
        },
        loadPerguntas(index, categoria) {
            if (!this.categorias[index].perguntas.length)
                this.$axios
                    .get(`faq/categorias/${categoria}`)
                    .then(response => {
                        this.$set(this.categorias[index], 'perguntas', response.data.registros)
                        this.$set(this.categorias, index, this.categorias[index])
                    })
            this.toggleItem(index, this.categoriasAtivas)
        },
        toggleItem(index, indices){
            let indice = indices.indexOf(index)
            if(indice > -1)
                indices.splice(indice, 1)
            else
                indices.push(index)
            this.$forceUpdate()
        },
    },
}
</script>

<style lang="stylus" scoped src="./Conteudo.styl"></style>